import { useState } from 'react'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { l } from '@manychat/manyui'

import { useAppDispatch, useAppSelector } from 'reduxTyped'
import { AiAutomationAnalytics } from 'apps/aiAutomation/lib/analytics'
import {
  AiAutomationToneOfVoiceActions,
  AiAutomationToneOfVoiceSelectors,
} from 'apps/aiAutomation/store/toneOfVoice'
import { AiAutomationTovState } from 'shared/api/requests/aiToneOfVoice/schemas'

export const useQuestionnaire = () => {
  const dispatch = useAppDispatch()

  const samples = useAppSelector(AiAutomationToneOfVoiceSelectors.getSamples)
  const state = useAppSelector(AiAutomationToneOfVoiceSelectors.getTovState)

  const totalCount = useAppSelector(AiAutomationToneOfVoiceSelectors.getTotalCount)
  const positiveCount = useAppSelector(AiAutomationToneOfVoiceSelectors.getPositiveCount)
  const activeSample = useAppSelector(AiAutomationToneOfVoiceSelectors.getActiveSample)

  const [isStrikeBroken, setIsStrikeBroken] = useState(false)
  const [showCommentForm, setShowCommentForm] = useState(false)

  const form = useForm({
    defaultValues: {
      user_reaction: '',
    },
    resolver: zodResolver(
      z.object({
        user_reaction: z
          .string()
          .min(5, l.translate('Provide more feedback to continue'))
          .max(
            1000,
            l.translate('Feedback must be {count} characters or fewer', {
              count: 1000,
            }),
          ),
      }),
    ),
  })

  const reset = () => {
    form.reset({
      user_reaction: '',
    })
  }

  const submitLike = () => {
    AiAutomationAnalytics.logTovSampleRated({
      is_positive_reaction: true,
      sample_index: activeSample,
      user_reaction: null,
    })

    dispatch(AiAutomationToneOfVoiceActions.sendPositiveReactionFx(samples[0]))

    setIsStrikeBroken(false)
    dispatch(AiAutomationToneOfVoiceActions.activeSampleMoved())
  }

  const submitDislike = ({ user_reaction }: { user_reaction: string }) => {
    AiAutomationAnalytics.logTovSampleRated({
      is_positive_reaction: false,
      user_reaction,
      sample_index: activeSample,
    })

    dispatch(
      AiAutomationToneOfVoiceActions.sendNegativeReactionFx({
        comment: user_reaction,
        sample: samples[activeSample],
      }),
    )
    setIsStrikeBroken(Boolean(activeSample + positiveCount))
    setShowCommentForm(false)
    reset()
  }

  return {
    form,
    setShowCommentForm,

    isStrikeBroken,
    isLoading: state === AiAutomationTovState.GENERATING_SAMPLES,
    isFinished: state === AiAutomationTovState.FINISHED || activeSample >= samples.length,
    currentStrike: activeSample + positiveCount,
    totalCount,

    samples,
    activeSample: Math.min(activeSample, samples.length - 1),
    showCommentForm,
    showControls: !showCommentForm && activeSample < samples.length,
    submitLike,
    submitDislike,
    reset,
  }
}
